import { Modal } from 'antd';
import type { History } from 'history';
import { useEffect } from 'react';

/**
 * Chiude le modal alla navigazione
 */
export function useModalHistoryCleanup(history: History) {
  useEffect(() => {
    const unlisten = history.listen(() => {
      Modal.destroyAll();
    });
    return () => {
      unlisten();
    };
  }, [history]);
}
